var _rect, _path, _path2, _circle, _circle2, _rect2, _rect3, _rect4, _circle3, _circle4, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNocatImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 102,
    viewBox: "0 0 134 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.1914,
    y: 19.8301,
    width: 94.6154,
    height: 69.2308,
    rx: 5.71322,
    fill: "#F6F6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.283 17.6908C115.058 17.9161 115.058 18.2814 115.283 18.5067C115.508 18.732 115.874 18.732 116.099 18.5067L115.283 17.6908ZM126.484 8.12204C126.709 7.89674 126.709 7.53145 126.484 7.30615C126.258 7.08084 125.893 7.08084 125.668 7.30615L126.484 8.12204ZM109.345 15.791C109.345 16.1096 109.603 16.3679 109.922 16.3679C110.241 16.3679 110.499 16.1096 110.499 15.791H109.345ZM110.499 0.791016C110.499 0.47239 110.241 0.214093 109.922 0.214093C109.603 0.214093 109.345 0.47239 109.345 0.791016H110.499ZM118.576 23.8679C118.257 23.8679 117.999 24.1262 117.999 24.4449C117.999 24.7635 118.257 25.0218 118.576 25.0218V23.8679ZM132.999 25.0218C133.317 25.0218 133.576 24.7635 133.576 24.4449C133.576 24.1262 133.317 23.8679 132.999 23.8679V25.0218ZM116.099 18.5067L126.484 8.12204L125.668 7.30615L115.283 17.6908L116.099 18.5067ZM110.499 15.791V0.791016H109.345V15.791H110.499ZM118.576 25.0218H132.999V23.8679H118.576V25.0218Z",
    fill: "#A6A6A6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1914 25.5433C18.1914 22.388 20.7493 19.8301 23.9046 19.8301H107.038C110.224 19.8301 112.807 22.4131 112.807 25.5993V27.907H18.1914V25.5433Z",
    fill: "#CFCFCF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.2369,
    cy: 23.8326,
    r: 1.4283,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32.9517,
    cy: 23.8326,
    r: 1.4283,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52.9961,
    y: 47.5215,
    width: 5.47869,
    height: 5.47869,
    rx: 2.73935,
    fill: "#989898"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 73.5586,
    y: 47.5215,
    width: 5.47869,
    height: 5.47869,
    rx: 2.73935,
    fill: "#989898"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 58.9961,
    y: 65,
    width: 14,
    height: 4,
    rx: 2,
    fill: "#989898"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 120.593,
    cy: 72.9053,
    r: 2.30769,
    fill: "url(#paint0_radial_4859_34727)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.23828,
    cy: 41.2422,
    r: 3.24219,
    fill: "url(#paint1_radial_4859_34727)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M29.2497 88.0276L29.1811 87.7839C28.8687 86.6512 28.7214 85.7215 28.7392 84.9948C28.7633 84.2663 28.9118 83.6445 29.1848 83.1292C29.456 82.6076 29.8213 82.0967 30.2806 81.5963C30.5948 81.2515 30.8623 80.8962 31.083 80.5306C31.3082 80.1569 31.459 79.7704 31.5354 79.3712C31.61 78.9658 31.5857 78.5443 31.4624 78.1069C31.3233 77.6133 31.0872 77.2179 30.7539 76.9206C30.4206 76.6233 30.0289 76.4302 29.5789 76.3411C29.1352 76.2503 28.6728 76.2727 28.1916 76.4082C27.748 76.5332 27.3535 76.7489 27.0082 77.0553C26.6673 77.3536 26.4203 77.7335 26.267 78.1948C26.1182 78.6482 26.1109 79.1729 26.2451 79.7691L22.9084 80.7092C22.6052 79.5132 22.6127 78.4387 22.931 77.4857C23.2555 76.531 23.8113 75.7269 24.5985 75.0735C25.3918 74.4183 26.3352 73.9367 27.4287 73.6286C28.6222 73.2924 29.7309 73.206 30.7549 73.3693C31.7851 73.531 32.6624 73.9279 33.3869 74.5601C34.1158 75.1843 34.629 76.0244 34.9265 77.0804C35.1272 77.7927 35.1912 78.4626 35.1184 79.0901C35.0519 79.7159 34.8709 80.3064 34.5755 80.8618C34.2801 81.4171 33.8934 81.9476 33.4153 82.4532C32.9972 82.9082 32.6733 83.3502 32.4434 83.7792C32.2198 84.2064 32.0941 84.6701 32.0664 85.1702C32.0432 85.6623 32.1218 86.2405 32.3022 86.9046L32.3708 87.1483L29.2497 88.0276ZM32.5283 93.4167C31.966 93.5751 31.4254 93.5116 30.9066 93.2262C30.3878 92.9407 30.0474 92.5105 29.8854 91.9357C29.727 91.3733 29.7945 90.8349 30.088 90.3206C30.3814 89.8063 30.8094 89.4699 31.3717 89.3115C31.9278 89.1548 32.4653 89.2192 32.9841 89.5046C33.5092 89.7884 33.851 90.2114 34.0094 90.7738C34.1168 91.1549 34.1176 91.529 34.012 91.896C33.9125 92.2612 33.733 92.5816 33.4734 92.8571C33.2183 93.1245 32.9033 93.3111 32.5283 93.4167Z",
    fill: "#B4B4B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M80.3604 19.348L80.4344 19.134C80.783 18.1422 81.1494 17.384 81.5334 16.8592C81.923 16.3363 82.3495 15.9552 82.8131 15.7159C83.2786 15.4712 83.8078 15.2822 84.4006 15.149C84.8075 15.0561 85.1854 14.9316 85.5342 14.7756C85.8904 14.616 86.1985 14.409 86.4584 14.1547C86.7202 13.8949 86.9174 13.5728 87.0501 13.1886C87.1999 12.7549 87.2283 12.3438 87.1351 11.9552C87.042 11.5667 86.8528 11.2248 86.5677 10.9297C86.288 10.6365 85.9368 10.4169 85.5141 10.2709C85.1243 10.1363 84.7244 10.0934 84.3143 10.1422C83.9116 10.1874 83.5362 10.3404 83.188 10.6011C82.8473 10.8583 82.5741 11.2401 82.3684 11.7466L79.437 10.7341C79.8247 9.70058 80.3787 8.91496 81.099 8.37726C81.8248 7.84145 82.6436 7.5344 83.5554 7.45611C84.4728 7.37971 85.4118 7.50742 86.3724 7.83923C87.4209 8.20138 88.2797 8.70383 88.9486 9.34656C89.623 9.99118 90.065 10.7306 90.2746 11.5649C90.4915 12.3956 90.4397 13.2748 90.1193 14.2026C89.9031 14.8284 89.6082 15.3532 89.2344 15.7771C88.8661 16.2029 88.4317 16.5444 87.9312 16.8017C87.4307 17.0589 86.8758 17.2513 86.2665 17.3787C85.727 17.4996 85.2633 17.659 84.8755 17.8568C84.4931 18.0566 84.1641 18.3331 83.8885 18.6864C83.6202 19.0362 83.3829 19.5011 83.1764 20.081L83.1024 20.2951L80.3604 19.348ZM80.0184 24.9811C79.5244 24.8105 79.1596 24.4879 78.9241 24.0133C78.6887 23.5387 78.6582 23.0489 78.8326 22.5439C79.0033 22.0498 79.3277 21.6887 79.8058 21.4607C80.284 21.2326 80.7701 21.2039 81.2642 21.3745C81.7527 21.5433 82.1148 21.8649 82.3502 22.3395C82.5912 22.816 82.6263 23.3012 82.4557 23.7953C82.34 24.1302 82.1497 24.4054 81.8847 24.6211C81.6252 24.8387 81.3298 24.9825 80.9985 25.0523C80.6745 25.1186 80.3478 25.0949 80.0184 24.9811Z",
    fill: "#B4B4B4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4859_34727",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(120.593 72.9053) rotate(90) scale(2.30769)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4859_34727",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(4.23828 41.2422) rotate(90) scale(3.24219)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBCBCB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNocatImage);
export default __webpack_public_path__ + "static/media/nocatImage.5d893dbce7bc83969a8a5ac87ee43aee.svg";
export { ForwardRef as ReactComponent };